import { render, staticRenderFns } from "./CustomFieldDialog.vue?vue&type=template&id=d54989a8&"
import script from "./CustomFieldDialog.vue?vue&type=script&lang=js&"
export * from "./CustomFieldDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports